import { HARD_PATHS } from '../utils/hard-paths';

const moduleRoot = `/strata-library`;

export const PATHS = {
    STRATA_LIBRARY: {
        path: `${moduleRoot}`,
    },
    OVERVIEW: {
        path: `${moduleRoot}/overview`,
    },
    FEATURES: {
        path: `${moduleRoot}/features`,
    },
    DOCUMENTATION: {
        path: `${moduleRoot}/pricing`,
        hardPath: HARD_PATHS.HELP.STRATA_DOCUMENTATION,
    },

    //NEW valid routes
    SOUND_EFFECTS_COLLECTIONS_ID: {
        path: `${moduleRoot}/sound-effects-collections/:libraryId`,
    },
    SOUND_EFFECTS_COLLECTIONS: {
        path: `${moduleRoot}/sound-effects-collections/`,
    },
    SOUND_EFFECTS_COLLECTIONS_COLLECTION: {
        path: `${moduleRoot}/sound-effects-collections/collection/:collectionId`,
    },
    SOUND_EFFECTS_COLLECTION_BAD: {
        path: `${moduleRoot}/sound-effects-collections/collection`,
    },

    //OLD collections routes still needed for backward compatibility
    COLLECTIONS_ID: {
        path: `${moduleRoot}/collections/:libraryId`,
    },
    COLLECTIONS: {
        path: `${moduleRoot}/collections/`,
    },
    COLLECTION: {
        path: `${moduleRoot}/collection/:collectionId`,
    },
    COLLECTION_BAD: {
        path: `${moduleRoot}/collection`,
    },
    PRICING_TAB: {
        path: `${moduleRoot}/pricing/:selectedTab`,
    },
    PRICING: {
        path: `${moduleRoot}/pricing`,
    },
    LICENSING: {
        path: `${moduleRoot}/licensing/faq/strataLicenses`,
    },
};
